(function () {
  window.google_trackConversion = function (opts = {}) {
    const known = ['onload_callback', 'conversion_callback', 'event_callback'];

    known.forEach(k => {
      if (typeof opts[k] === 'function') queueMicrotask(() => opts[k]());
    });

    Object.keys(opts).forEach(k => {
      if (k.endsWith('_callback') && typeof opts[k] === 'function') {
        queueMicrotask(() => opts[k]());
      }
    });

    return true;
  };
})();

(function () {
  if (!window.addthis) {
    window.addthis = {
      init: function (c) {},
      toolbox: function (s, c) {},
      share: function (opts = {}) {
        Object.keys(opts).forEach(k => {
          if (k.endsWith('_callback') && typeof opts[k] === 'function') {
            queueMicrotask(() => opts[k]());
          }
        });
      },
      addEventListener: function (e, h) {},
      config: {},
      shareVars: {},
      layers: {
        refresh: function () {},
        collapse: function () {},
        expand: function () {}
      }
    };
  }
})();


import './dependences'

import './modules'
import './configs'
import './factories'
import './services'
import './controllers'
import './controllers/admin'
import './controllers/blocks'
import './directives'
import './filters'
import './run'
